import React from "react";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import "./ElementOverlay.css";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";

export const ElementOverlay = props => {
  const { onDrag, dragHandleProps, onDelete } = props;
  const { selectedElement, targetElement, selectedContainer } = props;
  const className =
    targetElement.type === elementConstants.CONTAINER
      ? "element-overlay-container"
      : "element-overlay";

  const dir ="row";
  return (
    <React.Fragment>
    
      <div className={className}>
        <div
          className="selected-toolbar"
          style={{
            display:
              (selectedElement &&
                targetElement.contentId === selectedElement.contentId) || (selectedElement &&
                  targetElement.id === selectedElement.id) ||
                (selectedContainer &&
                  targetElement.contentId === selectedContainer.contentId)
                ? "inline-flex"
                : "none",
            flexDirection: dir,
          }}
        >
          <span onDrag={onDrag} {...dragHandleProps} className="element-floating-btn move">
            <DragIndicatorIcon className="drag-handle-icon" />
          </span>
          <span className="element-floating-btn delete">
            <i
              className="fa fa-trash"
              onClick={() => onDelete(targetElement)}
            />
          </span>
        </div>
      </div>
    </React.Fragment>
  );
};

export const ElementOverlayEmail = props => {
  const { onDrag, dragHandleProps, onDelete } = props;
  const { selectedElement, targetElement } = props;

  return (
    <React.Fragment>
      <div className={'element-overlay'}>
        <div
          className="selected-toolbar"
          style={{
            display:
              (selectedElement && targetElement.id === selectedElement.id)
                ? "inline-flex"
                : "none",
            flexDirection: 'row',
          }}
        >
          <span onDrag={onDrag} {...dragHandleProps} className="element-floating-btn move">
            <DragIndicatorIcon className="drag-handle-icon" />
          </span>
          <span className="element-floating-btn delete">
            <i
              className="fa fa-trash"
              onClick={() => onDelete(targetElement)}
            />
          </span>
        </div>
      </div>
    </React.Fragment >
  );
};